import { AgButton, AgModal, AgModalActions, AgModalContent, AgText } from 'src/components/ui';

export type ConfirmModalLabelProps = {
  title: string;
  prompt: string | React.ReactNode;
  action?: string;
  cancel?: string;
  /** @deprecated Use `destructive` prop instead */
  color?: string;
  /** When true, the action button will be styled as destructive (red) */
  destructive?: boolean;
};

export type ConfirmButtonProps = {
  handleClose: () => void;
  handleConfirm: () => void;
  disableConfirm?: boolean;
  open: boolean;
  /** Test ID for the confirm action button */
  confirmTestId?: string;
} & ConfirmModalLabelProps;

export default function ConfirmModal({
  title,
  prompt,
  action = 'Delete',
  cancel = 'Cancel',
  color,
  destructive = true,
  open,
  handleClose,
  handleConfirm,
  disableConfirm = false,
  confirmTestId,
}: ConfirmButtonProps) {
  // Support legacy color prop - if color is set to something other than error, don't use destructive
  const isDestructive = color ? color.includes('error') : destructive;
  return (
    <AgModal open={open} onClose={handleClose} title={title} size="sm">
      <AgModalContent>
        {typeof prompt === 'string' ? (
          <AgText size="16" className="whitespace-pre-line">
            {prompt}
          </AgText>
        ) : (
          prompt
        )}
      </AgModalContent>
      <AgModalActions
        cancel={
          <AgButton variant="white" onPress={handleClose}>
            {cancel}
          </AgButton>
        }
      >
        <AgButton
          variant={isDestructive ? 'destructive' : 'primary'}
          onPress={handleConfirm}
          isDisabled={disableConfirm}
          data-testid={confirmTestId}
        >
          {action}
        </AgButton>
      </AgModalActions>
    </AgModal>
  );
}
